import * as Types from '../../../gql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DeleteTokenCookieHook_signOutVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteTokenCookieHook_signOut = { signOut: Types.Scalars['Boolean'] | null };


export const DeleteTokenCookieHook_signOutDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTokenCookieHook_signOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signOut"}}]}}]} as unknown as DocumentNode<DeleteTokenCookieHook_signOut, DeleteTokenCookieHook_signOutVariables>;
import { useMutation, MutationHookOptions } from '@apollo/client'

export const useDeleteTokenCookieHook_signOut = (options?: MutationHookOptions<DeleteTokenCookieHook_signOut, DeleteTokenCookieHook_signOutVariables>) => useMutation(DeleteTokenCookieHook_signOutDocument, options);
